/*
 * @Author: Teemo Ding
 * @Date: 2021-09-24 09:54:23
 * @LastEditTime: 2021-10-08 15:17:25
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/DestinationAddressLocalisation/Components/SubdivisionTranslationSetting.tsx
 */
import { DebounceInput } from '@/src/components/Antd/Input/DebounceInput';
import Selector from '@/src/components/TableColSelector/ColSelector';
import React, { useEffect } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const SubdivisionTranslationSetting = ({
  value: shopperTransSettings = [],
  onChange,
  getFieldValue,
  notEditable,
}: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const singapore = getFieldValue('supportedLanguage');
  const [allColumns, setAllColumns] = React.useState([]);

  useEffect(() => {
    setAllColumns(
      (singapore || [])
        .filter((o, index) => index > 0)
        .map((item) => ({
          title: item,
          dataIndex: item,
          default: true,
          key: item,
          optional: true,
        })),
    );
  }, [singapore]);

  const onSelecterReset = () => {
    setAllColumns(
      allColumns.map((item) => ({
        ...item,
        default: true,
      })),
    );
  };

  const handleInputChange = (value, itemIndex, listIndex) => {
    shopperTransSettings[itemIndex].subdivisions[listIndex].name = value;
    onChange(shopperTransSettings);
  };

  return (
    <div>
      {!notEditable && (
        <div className={css.selector}>
          <Selector
            allColumns={allColumns}
            onChange={setAllColumns}
            setReset={onSelecterReset}
          />
        </div>
      )}
      <div className={css.table}>
        {shopperTransSettings.map((item, itemIndex) => {
          const filterLocale = allColumns.filter(
            (o) => o.title == item.locale && o.default,
          );
          return (
            (filterLocale.length > 0 || itemIndex == 0) && (
              <div className={css.col} key={itemIndex}>
                <div className={css.th}>
                  {itemIndex == 0
                    ? getI18n(
                        'storeLogistics.destinationAddressLocalisation.defaulten',
                      )
                    : item.locale}{' '}
                </div>
                <div>
                  {item.subdivisions.map((list, listIndex) => (
                    <div className={css.td} key={listIndex}>
                      <div className={css.defaultName}>
                        {itemIndex == 0 ? list.defaultName : ''}
                      </div>
                      <DebounceInput
                        onChange={(value) =>
                          handleInputChange(value, itemIndex, listIndex)
                        }
                        disabled={notEditable}
                        value={list.name}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )
          );
        })}
      </div>
    </div>
  );
};

export default SubdivisionTranslationSetting;
